export const chimpersNFTs = [
  
  {
    "id": "chimpers-5555",
    "name": "Chimpers #5555",
    "image": "https://arweave.net/sbEPC2PWVB_vWI_UsNaKvBOc_6HHUpbre9PhQubI6GQ/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5554",
    "name": "Chimpers #5554", 
    "image": "https://arweave.net/kSJC5aPtoNdJ7ch_mMw7-FoHFwtz7Ff5PwfU_X5mp5U/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5553",
    "name": "Chimpers #5553",
    "image": "https://arweave.net/LA2p41v-aG2lc6xcCe8RIx2cASXYEX-HEiYc9Tw_CQI/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5551",
    "name": "Chimpers #5551",
    "image": "https://arweave.net/y2Ct7SumaD5iQ8juMjgYOy8hibVYJqE4Q57-tpu1L4s/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5552",
    "name": "Chimpers #5552",
    "image": "https://arweave.net/Xr0dmk9iHq2tyMTF0tFuqfHlfKPhJsmJ6cEr6aBm-eo/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5550",
    "name": "Chimpers #5550",
    "image": "https://arweave.net/Tkxx6v8EF4NYNPa0sdBcK_fIjrdarlF6uO8xaMFeu8I/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5549",
    "name": "Chimpers #5549",
    "image": "https://arweave.net/E9R02WW7heVKrOycFsYxaMzJ895GgSeMPy62G7Zx-Gs/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5548",
    "name": "Chimpers #5548",
    "image": "https://qktbvijx2nzdmrfdefyoi4zmmld5cbxt6rg26nxozcmxa6y3jfka.arweave.net/gqYaoTfTcjZEoyFw5HMsYsfRBvP0Ta827siZcHsbSVQ/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5547",
    "name": "Chimpers #5547",
    "image": "https://arweave.net/6SPGnzkzEsPRJtk286Vd9QPy_m6uhwC7witHYShFAws/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5546",
    "name": "Chimpers #5546",
    "image": "https://arweave.net/0M-noAULahBGzfaDqgl3sS3v2dXtGZ1XPjuY6bByI08/",
    "price": "1.0 ETH"
  },
  {
    "id": "chimpers-5545",
    "name": "Chimpers #5545",
    "image": "https://mjemsshh2k5nahalfm453allc6cnjuyumtbhmiyrz22slus33xtq.arweave.net/YkjJSOfSutAcCys53YFrF4TU0xRkwnYjEc61JdJb3ec/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5544",
    "name": "Chimpers #5544",
    "image": "https://mjscefvrlz4e5z3rtq5se47vsdajw7nrj5nre7mbzee3tzs3ivza.arweave.net/YmQiFrFeeE7ncZw7InP1kMCbfbFPWxJ9gckJueZbRXI/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5543",
    "name": "Chimpers #5543",
    "image": "https://ffnii32vguikhchxer4mprregaofchy3gv6yvkr2yjysi7jyc2vq.arweave.net/KVqEb1U1EKOI9yR4x8YkMBxRHxs1fYqqOsJxJH04Fqs/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5542",
    "name": "Chimpers #5542",
    "image": "https://arweave.net/FrGVuLhGVXf4_I2NivXeqUMmg8WNQQULM_F8gpxWADc/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5541",
    "name": "Chimpers #5541",
    "image": "https://ypewigdlm43qh4655qszrw5e6jkvpzx52q5hnxtgbessxobotz3a.arweave.net/w8lkGGtnNwPz3ewlmNuk8lVX5v3UOnbeZgklK7gunnY/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5536",
    "name": "Chimpers #5536",
    "image": "https://arweave.net/3Fe0ECuu8lAOAujLCjc-oB3c8bXyYDaW7YjDcJOXsak/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5535",
    "name": "Chimpers #5535",
    "image": "https://arweave.net/Qw6Rg17BWu7O3xCykTWTRaVW1zMuwKGmdXWW4-EeJc0/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5540",
    "name": "Chimpers #5540",
    "image": "https://arweave.net/M0nIYph8-h8O4otgyGDKwBNcXvcZovBoKo757o7mI9Q/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5537",
    "name": "Chimpers #5537",
    "image": "https://2jtnutn4vpcniysaa2lncyely5pnrxricuubxzgv3ps7n6ughtsa.arweave.net/0mbaTbyrxNRiQAaW0WCLx17Y3igVKBvk1dvl9vqGPOQ/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5539",
    "name": "Chimpers #5539",
    "image": "https://arweave.net/9Hq_BHfWgOnPEGqUwUqMx7fOoZI4RAy2eh2b-2Z5Uv8/",
    "price": "1.0 ETH"
  },
    
  {
    "id": "chimpers-5538",
    "name": "Chimpers #5538",
    "image": "https://arweave.net/ixvx1i-xYu7pS-fe0D6peMNUVkr38yDpsP4Zjl57vCA/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5534",
    "name": "Chimpers #5534",
    "image": "https://arweave.net/BS-uQ6lwbrzF_ac2zO4Ga_QtK1383Z2ald1HRnMb6q0/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5533",
    "name": "Chimpers #5533",
    "image": "https://arweave.net/--ykb_rD6Egw2W3n_8Iq7SmLRPFFYuydG27fu6s73Tc/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5532",
    "name": "Chimpers #5532",
    "image": "https://arweave.net/eGTpyJXLD44MYddp8W2b45DpgDPjlPg4lUGs_RJ2nMQ/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5530",
    "name": "Chimpers #5530",
    "image": "https://arweave.net/NEe3sH4S7w99Iqm6wMNQHC4z10dEfEG_0JmQ69V7qLY/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5531",
    "name": "Chimpers #5531",
    "image": "https://arweave.net/oGiNfOruqOR4o9bGiNWxuIqJX_6PbGAHsWMdkTCdmBY/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5529",
    "name": "Chimpers #5529",
    "image": "https://yjnxbefiirib53vikjxgncwlls5pnmgwgzr56bzu4uzo4oxdrbja.arweave.net/wltwkKhEUB7uqFJuZorLXLr2sNY2Y98HNOUy7jrjiFI/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5527",
    "name": "Chimpers #5527",
    "image": "https://arweave.net/SJsy3RT0p6Quo_NKGs1FrPCqlMn5DUyGBKauyxTwhw0/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5528",
    "name": "Chimpers #5528",
    "image": "https://arweave.net/tNI_lxlKJ1Qn1PEn_10ieiKT0zNxfNhAJH7Y9K_mmOE/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5518",
    "name": "Chimpers #5518",
    "image": "https://arweave.net/qPjvR9PjDoXdZPjmFHKi87oIK_FyZ0lX0khLDHQEXeU/",
    "price": "1.0 ETH"
  },
  {
    "id": "chimpers-5526",
    "name": "Chimpers #5526",
    "image": "https://arweave.net/dMSi6VCeEUYOgdS8xHgLR75fStb8z3oKo6AeH_f9wGM/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5525",
    "name": "Chimpers #5525",
    "image": "https://nxkofa43mo5iiihxjolnklgonunwy7ivs7uy65bcn256qrvznnza.arweave.net/bdTig5tjuoQg90uW1SzObRtsfRWX6Y90Im676Ea5a3I/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5523",
    "name": "Chimpers #5523",
    "image": "https://arweave.net/sA-j9MO8dVfScu552D0CdiHyrf2qiNgIEocsNAGf6eg/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5524",
    "name": "Chimpers #5524",
    "image": "https://arweave.net/vZlbMuu1pFd-MdRUVGW-pcOie-Arw7pDjDSvlEQgotY/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5521",
    "name": "Chimpers #5521",
    "image": "https://ze2m7gpuapatvhbyzoofbgfunwnem34zn6k4t24rjqhfuyk5mnzq.arweave.net/yTTPmfQDwTqcOMucUJi0bZpGb5lvlcnrkUwOWmFdY3M/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5519",
    "name": "Chimpers #5519",
    "image": "https://6qttwpld4xtrrn3ow2eo35ieubceo45onrljiltwmnvnqxe5f5ya.arweave.net/9Cc7PWPl5xi3braI7fUEoERHc65sVpQudmNq2FydL3A/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5517",
    "name": "Chimpers #5517",
    "image": "https://arweave.net/Glr-Pe94cBw_0apUfrPfvJYwrNu2m4USWTWBYKfOluM/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5516",
    "name": "Chimpers #5516",
    "image": "https://arweave.net/d6AQcWeRXifEhegAQ9Cq3YW1W_7kME1rshqcd0MVmzk/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5522",
    "name": "Chimpers #5522",
    "image": "https://evrq2go32ataqsubqjypmunbt3jsxwfcwdocjuidujik672haybq.arweave.net/JWMNGdvQJghKgYJw9lGhntMr2KKw3CTRA6JQr39HBgM/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5512",
    "name": "Chimpers #5512",
    "image": "https://arweave.net/v2q0UfWSO6X9FKsbZ2TGF_ONARM7WA6Pc4jw0zZDPsU/",
    "price": "1.0 ETH"
  },
  {
    "id": "chimpers-5511",
    "name": "Chimpers #5511",
    "image": "https://arweave.net/4VnnxipTm-ta2wuO2Ofz4Q8Ahbc0oKN1ourc81HoKBQ/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5513",
    "name": "Chimpers #5513",
    "image": "https://arweave.net/Lw1Tr8eK-_4ctmDvPsBmFtluLSPdQkpq2p7_PSracoQ/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5514",
    "name": "Chimpers #5514",
    "image": "https://arweave.net/36It65B0o7H7D7I8ZGGvaI2_sclLEpBQNAxoA-7_lEg/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5520",
    "name": "Chimpers #5520",
    "image": "https://arweave.net/CObgsa1ZqQyl1yPu8OCpt4ZNZmwzA_lyxoo8rj6zv6c/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5510",
    "name": "Chimpers #5510",
    "image": "https://arweave.net/RSelSBP-nXl1mV7nZc5L5luL57QbyU3JtHVKuw3oI_M/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5515",
    "name": "Chimpers #5515",
    "image": "https://5m53zk4nmnwatxq4aaghzqvgyhlnevbduwf5zuwuiknva4yw5anq.arweave.net/6zu8q41jbAneHAAMfMKmwdbSVCOli9zS1EKbUHMW6Bs/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5508",
    "name": "Chimpers #5508",
    "image": "https://arweave.net/UkR146sno_1D6--dvFie-eEsjujL1kbW57qYrE0DKag/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5509",
    "name": "Chimpers #5509",
    "image": "https://vhde3tcqllugdfpvdq6qb7wrduowydepavqlhkpad43rxvno34iq.arweave.net/qcZNzFBa6GGV9Rw9AP7RHR1sDI8FYLOp4B83G9Wu3xE/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5507",
    "name": "Chimpers #5507",
    "image": "https://isy466bspdeglnc2jppqadwb45vop3pfcbxdw4uwpufyetpefhrq.arweave.net/RLHPeDJ4yGW0WkvfAA7B52rn7eUQbjtyln0Lgk3kKeM/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5506",
    "name": "Chimpers #5506",
    "image": "https://2lzaoghyonbf6xauneoisgvn3pcz5rhwybvctunuyyrn2tuzen3q.arweave.net/0vIHGPhzQl9cFGkciRqt28WexPbAainRtMYi3U6ZI3c/",
    "price": "1.0 ETH"
  },
  {
    "id": "chimpers-5505",
    "name": "Chimpers #5505",
    "image": "https://arweave.net/FIooOXywKqF9la8OL-hA3__WpkRFw0cFffC8u5RpKyM/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5500",
    "name": "Chimpers #5500",
    "image": "https://ub6ltkkewu2zkl64roiez4q4eyvxxbhzkjtkcnokslse4afppk5a.arweave.net/oHy5qUS1NZUv3IuQTPIcJit7hPlSZqE1ypLkTgCvero/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5501",
    "name": "Chimpers #5501",
    "image": "https://arweave.net/BP_t3535MntO52ozucCOVUYlIQ-lHjkYnT8eLczGhTI/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5504",
    "name": "Chimpers #5504",
    "image": "https://ohvobkhu25cg2qpjmh5tjvckldpooqqu3hvuwzlludbwihqygkpq.arweave.net/cergqPTXRG1B6WH7NNRKWN7nQhTZ60tla6DDZB4YMp8/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5503",
    "name": "Chimpers #5503",
    "image": "https://arweave.net/u0jjAvbe9ITPKNSuFIwLUWv4zS47eLQfH82J-pEG6qs/",
    "price": "0.9 ETH"
  },

  {
    "id": "chimpers-5496",
    "name": "Chimpers #5496",
    "image": "https://arweave.net/ODQ6G2ThU-SfUypaiFHGD7KF5Ij_Dm6mv1S6rv1zkfA/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5502",
    "name": "Chimpers #5502",
    "image": "https://arweave.net/uQbU2wIic3Ska8IWfhDWcupMMjI_dK2v2nH4EAa4X3g/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5498",
    "name": "Chimpers #5498",
    "image": "https://arweave.net/fbbA4yf6M-u0n-kgkUpcBwhsiyxvg1XaPqKnsPKS4GI/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5497",
    "name": "Chimpers #5497",
    "image": "https://arweave.net/S09tYRrWTuLhd9k1BBBaTU1j-dmapNVBhC-osHvC7CQ/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5499",
    "name": "Chimpers #5499",
    "image": "https://sojgrl2rdcdxqtdmbrck2pbbjq6whyl2lglctipcrgfhzifscqqa.arweave.net/k5Jor1EYh3hMbAxErTwhTD1j4XpZlimh4omKfKCyFCA/",
    "price": "1.0 ETH"
  },
  {
    "id": "chimpers-5495",
    "name": "Chimpers #5495",
    "image": "https://arweave.net/gGjQVGWVm7cwjkyj9N67ZC07D7F3LoB0FlMCV_j0fMo/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5494",
    "name": "Chimpers #5494",
    "image": "https://mccpdn3id4xfdnc2rhomzsh4hsggcy6hpg4lkln2oq4m3j2flz5q.arweave.net/YITxt2gfLlG0WonczMj8PIxhY8d5uLUtunQ4zadFXns/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5492",
    "name": "Chimpers #5492",
    "image": "https://s6kq2l3xyagq5fg6xjl252ozib7ekx4sudrdkormvgnj62c7ikea.arweave.net/l5UNL3fADQ6U3rpXrunZQH5FX5Kg4jU6LKman2hfQog/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5491",
    "name": "Chimpers #5491",
    "image": "https://4ocsq4nk3cdxmoorjosdj3ue3atflfvsanizirzfl5hlws7xr3ma.arweave.net/44UocarYh3Y50UukNO6E2CZVlrIDUZRHJV9Ou0v3jtg/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5493",
    "name": "Chimpers #5493",
    "image": "https://jstkdjaelh27kaynnohgdcgyrsig5ezgnsgkrza5hujonsilcvna.arweave.net/TKahpARZ9fUDDWuOYYjYjJBukyZsjKjkHT0S5skLFVo/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5489",
    "name": "Chimpers #5489",
    "image": "https://c4guyvoykfb2ju7hgtgu2c3sgzg7cnkoohiz62lezem7hutwyzla.arweave.net/Fw1MVdhRQ6TT5zTNTQtyNk3xNU5x0Z9pZMkZ89J2xlY/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5487",
    "name": "Chimpers #5487",
    "image": "https://mwrbsdw6f3wkakmmcyxf6ibmjmjpciltnspju6lloksjn5yvzo5a.arweave.net/ZaIZDt4u7KApjBYuXyAsSxLxIXNsnpp5a3KklvcVy7o/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5488",
    "name": "Chimpers #5488",
    "image": "https://xaqmu2d2fb3bfh32hztn2kocidzigy4qsw4bd2iuds4qamagk4xq.arweave.net/uCDKaHoodhKfej5m3SnCQPKDY5CVuBHpFBy5ADAGVy8/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5490",
    "name": "Chimpers #5490",
    "image": "https://arweave.net/9iYc9s8Kz-OO8xYJMlmkYZlOQbogIKUfb-DQtesTmjY/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5484",
    "name": "Chimpers #5484",
    "image": "https://arweave.net/IX27biTE3mUrWeazMDhps_bH1gr_qYDrLjv3ItjjEZY/",
    "price": "1.0 ETH"
  },
  {
    "id": "chimpers-5483",
    "name": "Chimpers #5483",
    "image": "https://arweave.net/mo-1H2S30l6uTJY1hraTLpEHmyPrmj3NSo7IWawHFHE/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5485",
    "name": "Chimpers #5485",
    "image": "https://arweave.net/4PD1Gguh8gwGsKBxHKj11y7flEX3MnYLXfQZ91H--90/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5486",
    "name": "Chimpers #5486",
    "image": "https://arweave.net/JvqeGq_aYQ1WQdQRTL-inhmu4RbrigFJmT8VoKgTp-M/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5482",
    "name": "Chimpers #5482",
    "image": "https://j53dhi5v2m24kn2pwimdbblcke67vlgopkaqqcxwiwgadmebxf5q.arweave.net/T3Yzo7XTNcU3T7IYMIViUT36rM56gQgK9kWMAbCBuXs/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5478",
    "name": "Chimpers #5478",
    "image": "https://arweave.net/7psOqsXP01goqEZzstgNrKA9k6UB1-7QfhV6V8wluhQ/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5479",
    "name": "Chimpers #5479",
    "image": "https://arweave.net/7oXmqKd9eJO1ISaH-ZgErAxDFSHytkVHZDGHjR1pok8/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5481",
    "name": "Chimpers #5481",
    "image": "https://arweave.net/LTFckjX4LnLe3-pvpH0TqBeCIDqszZRDW8S3F4b6mLo/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5477",
    "name": "Chimpers #5477",
    "image": "https://arweave.net/9UH1Lue81FO4y_GqbJ2w30qmgHgRRH0DODVcTd3wuXQ/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5476",
    "name": "Chimpers #5476",
    "image": "https://arweave.net/64emY3IzEnQVopOVbD37tQUiBZ8Q0Sm-129a9G6z_ik/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5480",
    "name": "Chimpers #5480",
    "image": "https://cwdpskbilpk3wk7ppjaq6eaum42ogitupeitzl2j6qisqounvc3a.arweave.net/FYb5KChb1bsr73pBDxAUZzTjInR5ETyvSfQRKDqNqLY/",
    "price": "1.0 ETH"
  },
  {
    "id": "chimpers-5475",
    "name": "Chimpers #5475",
    "image": "https://arweave.net/0647wJpMNwSNjUUGpJLaj70xycduREUeDwdEL-tvJeA/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5474",
    "name": "Chimpers #5474",
    "image": "https://arweave.net/cxtT-aSZ9XxvlG7lEsw1cyg79UkaSHY6xzr9dbC2z8A/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5473",
    "name": "Chimpers #5473",
    "image": "https://arweave.net/-ehOKCPSRgLWez4Ty1I9lHqomzO9fpXCFRrVMnwyGvA/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5472",
    "name": "Chimpers #5472",
    "image": "https://arweave.net/-iiqduYxQRzi0VgU-Xn4odkOs4mA7GcBokhPZrFNYCU/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5471",
    "name": "Chimpers #5471",
    "image": "https://arweave.net/61RlYLohwia-jrO70zL37R1kWApucZP88StYhKOLoIk/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5470",
    "name": "Chimpers #5470",
    "image": "https://5e6v3ynzrzub4kvaeojqfahcozea5lbyin4ivzcz23bztfihinma.arweave.net/6T1d4bmOaB4qoCOTAoDidkgOrDhDeIrkWdbDmZUHQ1g/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5469",
    "name": "Chimpers #5469",
    "image": "https://rwk3ahughm5svb3nstresaemhjebx2yhzztxiyyoympa5rdtljta.arweave.net/jZWwHoY7OyqHbZTiSQCMOkgb6wfOZ3RjDsMeDsRzWmY/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5468",
    "name": "Chimpers #5468",
    "image": "https://arweave.net/bWWIbHbx5OTgG3QZRmj8-JKwMeO7Ar59rloNIxw6VE0/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5467",
    "name": "Chimpers #5467",
    "image": "https://6onxvregrpfcpkcrfwhbewdx43huvjugjwcgqqyprpthnb5wjnsq.arweave.net/85t6xIaLyieoUS2OElh35s9KpoZNhGhDD4vmdoe2S2U/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5464",
    "name": "Chimpers #5464",
    "image": "https://arweave.net/u4R_kU6SLNP6VoatFVBYVBRUX5-fRhRY6Zk1Vp8_c6A/",
    "price": "1.0 ETH"
  },
  {
    "id": "chimpers-5466",
    "name": "Chimpers #5466",
    "image": "https://arweave.net/Q9SBUx8k2KbI3tv9bULo2CfwQ9bnqNpgE_66toxsOmI/",
    "price": "0.5 ETH"
  },
  {
    "id": "chimpers-5465",
    "name": "Chimpers #5465",
    "image": "https://arweave.net/QVG9Kctq2cyfeWwYrRNirv3RkXVFtvBgdN-m_UOzu7o/",
    "price": "0.8 ETH"
  },
  {
    "id": "chimpers-5463",
    "name": "Chimpers #5463",
    "image": "https://arweave.net/0Ksw2X7YLKo9guNyeKUW5vAm3bjW2J-LKZyhiyce_ac/",
    "price": "1.1 ETH"
  },
  {
    "id": "chimpers-5462",
    "name": "Chimpers #5462",
    "image": "https://is3xsbd55wngl3jf6ph5irjymtzhjapkr4tmgfqjvrwzksw3bb7q.arweave.net/RLd5BH3tmmXtJfPP1EU4ZPJ0geqPJsMWCaxtlUrbCH8/",
    "price": "0.4 ETH"
  },
  {
    "id": "chimpers-5461",
    "name": "Chimpers #5461",
    "image": "https://arweave.net/Vfyw_idLlmGdXney32oVnm7kbunhgt0U9Ru03EpMOpY/",
    "price": "0.9 ETH"
  },
  {
    "id": "chimpers-5460",
    "name": "Chimpers #5460",
    "image": "https://arweave.net/uE8DI_ePG_mPLytYbDmF0KZ2YgHpH-dHPByW9IeUNzU/",
    "price": "0.6 ETH"
  },
  {
    "id": "chimpers-5459",
    "name": "Chimpers #5459",
    "image": "https://m5cqwv2jqm44jezroa4hvpxxpbeqxbi3aijfd623n4jq2ktk3kza.arweave.net/Z0ULV0mDOcSTMXA4er73eEkLhRsCElH7W28TDSpq2rI/",
    "price": "1.2 ETH"
  },
  {
    "id": "chimpers-5458",
    "name": "Chimpers #5458",
    "image": "https://arweave.net/9zWLtfFFJK32gPvHKwGATleuMpKYnDNLs-7TerCnaP0/",
    "price": "0.3 ETH"
  },
  {
    "id": "chimpers-5457",
    "name": "Chimpers #5457",
    "image": "https://t65vydokceoze4gg6hhncjbfnijr2q2y5f7yjjvjr3ptppftpcma.arweave.net/n7tcDcoRHZJwxvHO0SQlahMdQ1jpf4SmqY7fN7yzeJg/",
    "price": "0.7 ETH"
  },
  {
    "id": "chimpers-5456",
    "name": "Chimpers #5456",
    "image": "https://v6gf66ed5dfwxol3pk6khomzkhchi4boibnqavlcexxrtrmptzeq.arweave.net/r4xfeIPoy2u5e3q8o7mZUcR0cC5AWwBVYiXvGcWPnkk/",
    "price": "1.0 ETH"
  }






];